/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TooltipComponent} from './tooltip.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [TooltipComponent],
    exports: [
        TooltipComponent
    ],
    imports: [
        CommonModule,
        NgbModule
    ]
})
export class TooltipModule {
}
